import whyUnipathImage from "Assets/images/why-unipath-image.png";
import { useSelector } from "react-redux";

const WhyUnipath = () => {
  const whyUnipath = useSelector((e) => e?.states?.homePageData?.why_unipath);

  return (
    <div className="container">
      <div className="row">
        <div className="col-12">
          <div className="why-unipath-wrapper">
            <div className="why-unipath-content">
              <div className="section-heading">
                <h2>{whyUnipath?.heading}</h2>
                <p>{whyUnipath?.description}</p>
              </div>

              <div className="why-unipath-listing">
                {whyUnipath?.content?.map((item) => (
                  <div className="why-unipath-item">
                    <figure className="why-unipath-icon">
                      <img src={item?.icon} alt="" />
                    </figure>
                    <div className="why-unipath-item-content">
                      <h3>{item?.title}</h3>
                      <p>{item?.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <figure className="why-unipath-image">
              <img src={whyUnipathImage} alt="" />
            </figure>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhyUnipath;
